var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormWrapper',{staticClass:"px-12 pt-8 pb-12 bg-white rounded",attrs:{"formData":_vm.dataObject,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }